import { Navigate, Route, Routes } from "react-router";
import ProtectedAdminRoute from "./ProtectedRoutes/ProtectedAdminRoute";
import AddNewFood from "./pages/AdminPanel/AddNewFood";
import AllPosts from "./pages/AdminPanel/AllPosts";
import ReviewRequest from "./pages/AdminPanel/ReviewRequest";
import CategoryAdmin from "./pages/AdminPanel/CategoryAdmin";
import AllUsers from "./pages/AdminPanel/AllUsers";
import AdminPanel from "./pages/AdminPanel/AdminPanel";
import Login from "./pages/Login/Login";
import RestaurantProfile from "./pages/RestaurantAdmin/RestaurantProfile";
import ProtectedRestaurantRoute from "./ProtectedRoutes/ProtectedRestaurantRoute";
import RestuarantPanel from "./pages/RestaurantAdmin/RestuarantPanel";
import KrijoMenu from "./pages/RestaurantAdmin/KrijoMenu";
import MonitorimiKerkesave from "./pages/RestaurantAdmin/MonitorimiKerkesave";
import { LandingPage } from "./pages/Public/LandingPage";
import Register from "./pages/Register/Register";
import { useSelector } from "react-redux";
import { RootState } from "./redux/store";
import ForgetPassword from "./pages/ResetPassword.tsx/ForgotPassword";
import ResetPassword from "./pages/ResetPassword.tsx/ResetPassword";
import './locales/i18n';

function App() {
  const { token } = useSelector((state: RootState) => state.auth);

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="login" element={<Login />} />
      {!token ? (
        <>
          <Route path="password/reset" element={<ResetPassword />} />
          <Route path="forgotPassword" element={<ForgetPassword />} />
          <Route path="register" element={<Register />} />
        </>
      ) : (
        <>
          <Route path="password/reset" element={<Navigate to="/" replace />} />
          <Route path="forgotPassword" element={<Navigate to="/" replace />} />
          <Route path="register" element={<Navigate to="/" replace />} />
        </>
      )}

      <Route path="/restaurant-panel" element={<ProtectedRestaurantRoute />}>
        <Route path="" element={<RestuarantPanel />}>
          <Route path="restaurant-profile" element={<RestaurantProfile />} />
          <Route path="krijo-menu" element={<KrijoMenu />} />
          <Route
            path="monitorimi-kerkesave"
            element={<MonitorimiKerkesave />}
          />
        </Route>
      </Route>

      <Route path="/admin-panel" element={<ProtectedAdminRoute />}>
        <Route path="" element={<AdminPanel />}>
          <Route path="add-new-food" element={<AddNewFood />} />
          <Route path="allposts" element={<AllPosts />} />
          <Route path="review-request" element={<ReviewRequest />} />
          <Route path="category" element={<CategoryAdmin />} />
          <Route path="allusers" element={<AllUsers />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
